<template>
    <div>

        <!-- Records -->
        <div class="ar-records">
            <div
                class="ar-records__record"
                :key="record.id"
                v-for="(record, idx) in soundFiles">

                <!-- Single soundfile: -->
                <div class="recording-box cursor-pointer my-2 flex" @click="togglePlayback(idx)">
                    <div class="recording-box__inner flex">
                        <Player :record="record" :idx="idx" ref="player"></Player>
                        <div class="flex-grow ml-2" v-if="maxRecordings > 1">
                            Aufnahme {{ getSoundFileNumber(idx) }} <span v-if="record.duration">({{ record.duration }})</span>
                        </div>
                        <div class="flex-grow ml-2" v-else>
                            Aufnahme <span v-if="record.duration"><nobr>({{ record.duration }} sek)</nobr></span>
                        </div>
                    </div>
                    <span @click="removeRecord(idx)" class="icon-trash"></span>
                </div>
            </div>
        </div>
        <div v-if="soundFiles.length == 0 || soundFiles.length < maxRecordings">
            <button v-if="!isRecording" class="btn btn-primary--brand uppercase"
                @click="startRecorder">Stimme aufnehmen</button>
            <button v-else class="btn btn-primary--brand uppercase"
                :disabled="!isRecording || initUserMedia || isCountdown"
                @click="stopRecorder">Aufnahme stoppen</button>
        </div>
    </div>

</template>

<script>
import { mapFields } from 'vuex-map-fields';
import Player from "./Player.vue";
import Pipeline from "~/scripts/Pipeline/Pipeline.js";

export default {
    components: {
        Player
    },
    data () {
        return {
            recordList: [],
        }
    },

    computed: {
        ...mapFields({
            soundFiles: 'soundFiles',
            isRecording: 'isRecording',
            isCountdown: 'isCountdown',
            initUserMedia: 'initUserMedia',
            maxRecordings: 'theme.maxRecordings',
        })
    },
    mounted () {
        // init: read uploaded files from store into local recordList
        if(this.$store.state.soundFiles) {
            this.recordList = this.$store.state.soundFiles;
        }
    },

    methods: {
        /**
         * When the user recorded a voice, add the file to the vuex store
         * @param recording
         */
        afterRecording(recording) {
            // // add to store
            this.$store.commit('addSoundFile', recording);

            // commit event on root element
            let element = document.getElementById('ayv-container');
            element.dispatchEvent(new CustomEvent("soundRecordsChanged", {
                detail: {
                    soundFiles: this.$store.state.soundFiles
                }
            }));
        },

        startRecorder() {
            this.$root.$emit('startRecorder');
        },

        stopRecorder() {
            this.$root.$emit('stopRecorder');
        },

        removeRecord(idx) {
            // this.$store.commit('removeSoundFile', idx);

            this.$store.commit('resetState');
            // this.$store.state.stage.destroy()
            this.$nextTick(() => {
                Pipeline.runPipeline();
            });
        },

        getSoundFileNumber(idx) {
            const removedIndex = this.$store.state.removedIndex;
            return removedIndex !== null && removedIndex <= idx ? idx + 2 : idx + 1;
        },

        togglePlayback(idx) {
            const player = this.$refs.player[idx];
            if (player) {
                player.playback();
            }
        }
    },

}
</script>


